import { SvgAttribute } from "@/shared/constants/constants";

export const COMPONENT_NAME = "shared-verification-status";

export const SVG: SvgAttribute = {
  warning: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3.5 19 6v5.6c0 4.2-2.8 7.9-7 8.9-4.2-1-7-4.7-7-8.9V6l7-2.5Z"/>
    <path d="M12 8.2v4.8M12 16.1h.01"/>
  </svg>`,
  success: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3.5 19 6v5.6c0 4.2-2.8 7.9-7 8.9-4.2-1-7-4.7-7-8.9V6l7-2.5Z"/>
    <path d="m8.6 12.1 2.2 2.2 4.7-4.8"/>
  </svg>`,
};
